export default __webpack_public_path__ + "static/media/medicare-sample-card.f3d2d9b3.png";